/* COMPONENT IMPORTS*/
import { ErrorPage } from "../../components/ErrorPage/ErrorPage";
import BenefitsPie from "../../components/BenefitsPie/BenefitsPie";
import { SavingsCard } from "../../components/Home/SavingsCard";
import { ProtectionSavingsCard } from "../../components/Home/ProtectionSavingsCard";
import { Loading } from "../../components/Loading/Loading";
import NotificationBanner from "../../components/Notifications/NotificationBanner";
import ContextConstructor from "../../components/Context/Context";
import { LandingPage } from "../../components/HomeNoAssociate/LandingPage";
import { NotAssociateHome } from "../../components/HomeNoAssociate/NotAssociateHome";

/* MODULE IMPORTS */
import { NavLink } from "react-router-dom";
import React, { Component } from "react";
import { CarouselProvider, Slider, Slide, DotGroup } from "pure-react-carousel";
import { ReactPlugin, withAITracking } from "@microsoft/applicationinsights-react-js";

/* CSS IMPORT */
import "./Home.css";
import "pure-react-carousel/dist/react-carousel.es.css";

import sendLogError from "../../sendLogError";
import protecaopoupancaImg from "../../images/protecaopoupanca.svg";
import moreImg from "../../images/more.png";
import protecaoImg from "../../images/protecao.svg";
import zeroGraphImg from "../../images/zeroGraph.png";
import newseriesImg from "../../images/newseries.png";

const pageid = "14595";
var reactPlugin = new ReactPlugin();
class Home extends Component {
  static displayName = Home.name;

  constructor(props) {
    super(props);
    this.state = {
      portfolioData: [],
      portfolioCardsData: [],
      benefitData: [],
      error: [],
      loadingB: true,
      loadingP: true,
      failure: false,
      benefits: [],
      totalBenefits: 0,
      benefitsByCategory: [],
      toggleActive: true,
      active: "aTab",
      hasBenefits: false,
      DateString: [],
      DateStringValue: "",
      DateStart: new Date(),
      DateEnd: new Date(),
      DateStartCalendar: new Date(),
      DateEndCalendar: new Date(),
      Sort: "1",
      filtered: [],
      select2: undefined,
      sortSelect: "Maior Poupança",
    };
  }

  componentDidMount() {
    const { selectedUserID } = this.context;

    if (selectedUserID) {       
      this.populatePortfolioCardsData();
      this.populateBenefitsByCategoryData();      
    }

    this.getScrollPositionForCss();
  }

  componentWillUnmount() {
    if (this.abortControllerPortfolio) {
        this.abortControllerPortfolio.abort();
    }
    
    if (this.abortControllerBenefits) {
        this.abortControllerBenefits.abort();
    }
  }

  getScrollPositionForCss = () => {
    const debounce = (fn) => {
      let frame;
      return (...params) => {
        if (frame) {
          cancelAnimationFrame(frame);
        }
        frame = requestAnimationFrame(() => {
          fn(...params);
        });
      };
    };

    const storeScroll = () => {
      document.documentElement.dataset.scroll = window.scrollY;
    };

    document.addEventListener("scroll", debounce(storeScroll), {
      passive: true,
    });

    storeScroll();
  };

  renderDashboard() {
    return (
        <div>
            <div className="modalidades-title-home">
                <span className="b-modalidades-title-span">As minhas modalidades</span>
            </div>
            <br />
        <div className="modalidades-home">
          <SavingsCard
                    income={this.state.portfolioCardsData?.savings?.totalAmounts?.totalInvestedAmount}
                    gain={this.state.portfolioCardsData?.savings?.totalAmounts?.totalReceivedAmount}
          />
          <ProtectionSavingsCard
            protectionCurrentAmount={
                  this.state.portfolioCardsData?.protection?.totalAmounts?.totalCurrentAmount
            }
            protectionsavingsCurrentAmount={
                this.state.portfolioCardsData?.savingsPlusProtection?.totalAmounts?.totalCurrentAmount
            }
          />
        </div>
        <div className="carousel-wrapper">
          <CarouselProvider
            naturalSlideWidth={400}
            naturalSlideHeight={500}
            totalSlides={3}
            visibleSlides={1}>
            <Slider>
              <Slide index={0}>
                <SavingsCard
                    income={this.state.portfolioCardsData.savings.totalAmounts.totalInvestedAmount}
                     gain={this.state.portfolioCardsData.savings.totalAmounts.totalReceivedAmount}
                />
              </Slide>
              <Slide index={1}>
                <div className="poupanca">
                  <div className="title-home">Proteção</div>
                  <NavLink to="/protecao" style={{ textDecoration: "none" }}>
                    <div className="poupanca-card">
                      <img src={protecaopoupancaImg} alt=""></img>
                      <div className="poupanca-income">
                        {new Intl.NumberFormat("de-DE", {
                          style: "currency",
                          currency: "EUR",
                        }).format(
                            this.state.portfolioCardsData.savingsPlusProtection.totalAmounts
                            .totalCurrentAmount,
                        )}
                      </div>
                      <div className="poupanca-gain">Proteção+Poupança</div>
                      <div className="poupanca-description">Capital Subscrito</div>
                      <div className="subscribe">
                        <img
                          src={moreImg}
                          alt="Botão de subscrever"
                          width="60px"
                          height="60px"></img>
                        <div>Subscrever</div>
                      </div>
                    </div>
                  </NavLink>
                </div>
              </Slide>
              <Slide index={2}>
                <div className="poupanca">
                  <div className="title-home">Proteção</div>
                  <NavLink to="/protecao" style={{ textDecoration: "none" }}>
                    <div className="poupanca-card">
                      <img src={protecaoImg} alt=""></img>
                      <div className="poupanca-income">
                        {new Intl.NumberFormat("de-DE", {
                          style: "currency",
                          currency: "EUR",
                        }).format(
                            this.state.portfolioCardsData.protection.totalAmounts.totalCurrentAmount,
                        )}
                      </div>
                      <div className="poupanca-gain">Proteção</div>
                      <div className="poupanca-description">Capital Protegido</div>
                      <div className="subscribe">
                        <img
                          src={moreImg}
                          alt="Botão de subscrever"
                          width="60px"
                          height="60px"></img>
                        <div>Subscrever</div>
                      </div>
                    </div>
                  </NavLink>
                </div>
              </Slide>
            </Slider>
            <DotGroup />
          </CarouselProvider>
        </div>
      </div>
    );
  }

  renderBenefitsDashboard() {

      var grafico =
          this.state.totalBenefits > 0 ? (
        <BenefitsPie
                  data={this.state?.benefitsByCategory?.benefitsByCategory || []}
                  valorPoupado={this.state.totalBenefits}
        />
      ) : (
        <div>
          <img
            className="zero-benefits"
            src={zeroGraphImg}
            alt="benefícios"></img>
        </div>
      );

    const pieChart = () => {
      if (this.state.toggleActive)
        return (

            <div>
                <br />
                <br />
                <div className="pie-div-home-title">
                    <span className="b-modalidades-title-span">Os meus benefícios</span>
                </div>
            <div className="pie-div pie-div-home">
            {grafico}
            <div className="title-benefits">
              Benefícios
            </div>
            <NavLink to="/beneficios">
              <img
                className="plus-icon-orange"
                src={newseriesImg}
                to="/beneficios"
                alt="Botão de subscrever"
                width="60px"
                height="60px"></img>
              <div className="detail-benefits">Ver detalhe</div>
                    </NavLink>
            </div>
          </div>
        );
    };

    //console.log("valor do beneficio", this.state.benefits.totalBenefits);

    return <div>{pieChart()}</div>;
  }

  NotAssociateHomepage() {
    let entityWithMinors = this.context.mymUsers.length > 1 ? true : false;
    //let entityIsNotAssociate = (this.context.selectedUser.userState == "NOTASSOCIATE" || this.context.selectedUser.status == "NATIVO") ? true : false

    // console.log(
    //   "entityWithMinors: ",
    //   entityWithMinors /*, " entityIsNotAssociate: ", entityIsNotAssociate*/,
    // );

    if (entityWithMinors === false) {
      return <LandingPage />;
    } else {
      return <NotAssociateHome />;
    }
  }

  render() {
    const benefitsContent =
      this.state.loadingB || this.context.selectedUserID === "" ? (
        <Loading />
      ) : this.state.error || this.context.selectedUserID === "" ? (
        <ErrorPage />
      ) : (
        this.renderBenefitsDashboard(this.state.benefitData)
      );

    let portfolioContent =
      this.state.loadingP || this.context.selectedUserID === "" ? (
        <Loading />
      ) : this.state.error || this.context.selectedUserID === "" ? (
        <ErrorPage />
      ) : (
        this.renderDashboard(this.state.portfolioData)
      );

    let content =
      this.context.selectedUser.userState == "NOTASSOCIATE" ||
      this.context.selectedUser.status == "NATIVO" ? (
        <div className="main">
          <NotificationBanner />
          {this.NotAssociateHomepage()}
        </div>
      ) : (
        <div className="main">
          <NotificationBanner />
          {portfolioContent}
          {benefitsContent}
        </div>
      );

    //return (
    //    <div className="main" >
    //        <NotificationBanner />
    //        {/*{benefitsContent}*/}
    //        {/*{portfolioContent}*/}
    //        {this.NotAssociateHomepage()}
    //    </div>
    //);

    return <React.Fragment>{content}</React.Fragment>;
  }

  async populatePortfolioData() {
    try {
        const { selectedUserID, idToken } = this.context;

        const headers = {
            Authorization: `Bearer ${idToken}`,
            clientId: selectedUserID,
        };

        const response = await fetch("/Portfolio/GetPortfolio", {
            headers,
        });

        if (!response.ok) {
            throw new Error(`Erro HTTP: ${response.status}`);
        }

        const data = await response.json();

        this.setState({
            portfolioData: data,
            error: false,
            loadingP: false,
        });

    } catch (error) {
        console.error("Error fetching portfolio:", error);

        this.setState({
            error: true,
            loadingP: false,
        });

        sendLogError(error.message, "populatePortfolioData");

        if (error.message.includes("204")) {
            console.log("No Content!");
        }
    }
  }

  async populatePortfolioCardsData() {
    try {
      // cancelar anterior        
      if (this.abortControllerPortfolio) {
        this.abortControllerPortfolio.abort();
      }
        
      this.abortControllerPortfolio = new AbortController();

      const { selectedUserID, idToken } = this.context;

      const response = await fetch("/Portfolio/GetPortfolioCards", {
          headers: {
              Authorization: `Bearer ${idToken}`,
              clientId: selectedUserID,
          },
          signal: this.abortControllerPortfolio.signal
      });

      if (!response.ok) {
        throw new Error(`Erro HTTP: ${response.status}`);
      }

      const data = await response.json();

      this.setState({
          portfolioCardsData: data,
          error: false,
          loadingP: false,
      });
    } catch (error) {
        if (error.name === "AbortError") {
          return;
        }

        console.error("Error fetching portfolio cards:", error);

        this.setState({
          error: true,
          loadingP: false,
        });

        sendLogError(error.message, "populatePortfolioCardsData");
    }
  }

  async populateBenefitsByCategoryData() {
    try {
        // cancelar anterior
        if (this.abortControllerBenefits) {
            this.abortControllerBenefits.abort();
        }

        this.abortControllerBenefits = new AbortController();
        
        const { selectedUserID, idToken } = this.context;
       
        const response = await fetch("/Benefits/GetBenefitsByCategory", {
            headers: {
                Authorization: `Bearer ${idToken}`,
                clientId: selectedUserID,
            },
            signal: this.abortControllerBenefits.signal
        });

        if (!response.ok) {
            throw new Error(`Erro HTTP: ${response.status}`);
        }

        const data = await response.json();

        const totalBenefits = Number(data?.totalBenefits || 0);
        const hasBenefits = totalBenefits > 0;

        this.setState({
            benefitsByCategory: data,
            totalBenefits,
            hasBenefits,
            error: false,
            loadingB: false,
        });

    } catch (error) {
        if (error.name === "AbortError") {
          return;
        }

        console.error("Error fetching benefits by category:", error);

        this.setState({
            error: true,
            loadingB: false,
            hasBenefits: false,
        });

        sendLogError(error.message, "populateBenefitsByCategoryData");

        if (error.message.includes("204")) {
            console.log("Benefits no content");
        }
    }
  }

  async populateBenefitsData() {
    try {
        const { selectedUserID, idToken } = this.context;

        const headers = {
            Authorization: `Bearer ${idToken}`,
            clientId: selectedUserID,
        };

        const response = await fetch("/Benefits/GetBenefits", {
            headers,
        });

        if (!response.ok) {
            throw new Error(`Erro HTTP: ${response.status}`);
        }

        const data = await response.json();

        const benefitsAll = Array.isArray(data?.benefitsAll)
            ? data.benefitsAll
            : [];

        let DateString = "";

        if (benefitsAll.length > 0) {
            DateString =
                new Intl.DateTimeFormat("pt-PT").format(
                    new Date(benefitsAll[0].transactionDate)
                ) +
                " - " +
                new Intl.DateTimeFormat("pt-PT").format(new Date());
        }

        const totalBenefits = Number(data?.totalBenefits || 0);
        const hasBenefits = totalBenefits > 0;

        this.setState({
            benefits: data,
            DateString,
            hasBenefits,
            error: false,
            loadingB: false,
        });

    } catch (error) {
        console.error("Error fetching benefits:", error);

        this.setState({
            error: true,
            loadingB: false,
            hasBenefits: false,
        });

        sendLogError(error.message, "populateBenefitsData");

        if (error.message.includes("204")) {
            console.log("No content!");
        }
    }
  }
}

Home.contextType = ContextConstructor;

export default withAITracking(reactPlugin, Home);
